const configurationManager = require('../config/configurationManager');


module.exports.getUrl = function(resourceName)
{
    const cloudName = configurationManager.getConfig().cdnUsersCloudName;
    return `https://res.cloudinary.com/${cloudName}/image/upload/${resourceName}`
}
